import { defineStore } from 'pinia'

import { createCommonActions } from './actions'
import { createCommonState } from './state'

export const useCommonStore = defineStore('common', () => {
    const state = createCommonState()
    const actions = createCommonActions(state)

    return {
        ...state,
        ...actions
    }
})
